import { format } from 'date-fns';
import { ar } from 'date-fns/locale';

export const formatDate = (date: string | Date, formatStr: string = 'dd/MM/yyyy'): string => {
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, formatStr, { locale: ar });
  } catch {
    return '';
  }
};

export const formatDateTime = (date: string | Date): string => {
  return formatDate(date, 'dd/MM/yyyy - HH:mm');
};

export const formatCurrency = (amount: number, _currency?: string): string => {
  // Latin digits, comma grouping — the UI does not use Arabic-Indic numerals
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatPhone = (phone: string | undefined | null): string => {
  // Format Saudi phone numbers: +966 XX XXX XXXX
  if (!phone) return '';

  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.startsWith('966')) {
    const number = cleaned.slice(3);
    return `+966 ${number.slice(0, 2)} ${number.slice(2, 5)} ${number.slice(5)}`;
  }

  if (cleaned.startsWith('0')) {
    const number = cleaned.slice(1);
    return `0${number.slice(0, 2)} ${number.slice(2, 5)} ${number.slice(5)}`;
  }

  return phone;
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};
